import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LoadingService } from './service/loading.service';
import { NetworkService } from './service/network.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'my-app';
  isLoading$: Observable<boolean> | undefined;
  private networkStatusSubscription: Subscription | undefined;

  constructor(private loadingService: LoadingService, private networkService: NetworkService) {}

  ngOnInit(): void {
    this.isLoading$ = this.loadingService.isLoading$;
    this.networkStatusSubscription = this.networkService.networkStatus$.subscribe(isOnline => {
      console.log('App Component: Network status changed to', isOnline ? 'online' : 'offline');
      // Additional logic here if needed, e.g., disabling buttons or showing a different UI element
    });
  }

  ngOnDestroy(): void {
    this.networkStatusSubscription?.unsubscribe();
  }
}